// import config from "./config";
import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import { config } from "../helpers";
// import { tools } from "../helpers";

export const etaService = {
  getPickupTimeWindows,
  calculateETA
};

function getPickupTimeWindows(
  accountId,
  pickupZip,
  deliveryZip,
  pickupFromDate,
  pickupFromTime
) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    customerId: accountId,
    pickupZip: pickupZip,
    deliveryZip: deliveryZip,
    timeset: { from: pickupFromDate + "T" + pickupFromTime }
  };

  return Axios.post(
    `${config.apiUrlTools}/Tools/PickupTimeWindows`,
    body,
    requestOptions
  ).then(handleResponse);
}

function calculateETA(
  accountId,
  pickupZip,
  deliveryZip,
  pickupFromDate,
  pickupFromTime,
  pickupToDate,
  pickupToTime,
  stopDrivetimes
) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    customerId: accountId,
    pickupZip: pickupZip,
    deliveryZip: deliveryZip,
    timeset: {
      from: pickupFromDate + "T" + pickupFromTime,
      to: pickupToDate + "T" + pickupToTime
    },
    stopDrivetimes: stopDrivetimes
  };

  // tools.logAxios(
  //   `${config.apiUrlTools}/Tools/CalculateETA`,
  //   body,
  //   requestOptions
  // );

  return Axios.post(
    `${config.apiUrlTools}/Tools/CalculateETA`,
    body,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  if (response.status != "200") {
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response.data;
}
